/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelLoanersParams,
  ModelLoaner,
  ModelLoanerInput,
  ModelLoaners,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Loaner
 */
export const createModelLoaner = (
    modelLoanerInput: MaybeRefOrGetter<ModelLoanerInput>,
 signal?: AbortSignal
) => {
      modelLoanerInput = toValue(modelLoanerInput);

      return axiosClient<ModelLoaner>(
      {url: `/model-loaners`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelLoanerInput, signal
    },
      );
    }




export const getCreateModelLoanerMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelLoaner>>, TError,{data: ModelLoanerInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelLoaner>>, TError,{data: ModelLoanerInput}, TContext> => {

const mutationKey = ['createModelLoaner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelLoaner>>, {data: ModelLoanerInput}> = (props) => {
          const {data} = props ?? {};

          return  createModelLoaner(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelLoanerMutationResult = NonNullable<Awaited<ReturnType<typeof createModelLoaner>>>
    export type CreateModelLoanerMutationBody = ModelLoanerInput
    export type CreateModelLoanerMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create Model Loaner
 */
export const useCreateModelLoaner = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelLoaner>>, TError,{data: ModelLoanerInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelLoaner>>,
        TError,
        {data: ModelLoanerInput},
        TContext
      > => {
      return useMutation(getCreateModelLoanerMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Loaners list
 */
export const listModelLoaners = (
    params?: MaybeRefOrGetter<ListModelLoanersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelLoaners>(
      {url: `/model-loaners`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelLoanersQueryKey = (params?: MaybeRefOrGetter<ListModelLoanersParams>,) => {
    return [
    'model-loaners', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelLoanersQueryOptions = <TData = Awaited<ReturnType<typeof listModelLoaners>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelLoanersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelLoaners>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelLoanersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelLoaners>>> = ({ signal }) => listModelLoaners(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelLoaners>>, TError, TData>
}

export type ListModelLoanersQueryResult = NonNullable<Awaited<ReturnType<typeof listModelLoaners>>>
export type ListModelLoanersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Loaners list
 */

export function useListModelLoaners<TData = Awaited<ReturnType<typeof listModelLoaners>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelLoanersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelLoaners>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelLoanersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Loaner
 */
export const destroyModelLoaner = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-loaners/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelLoanerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelLoaner>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelLoaner>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyModelLoaner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelLoaner>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyModelLoaner(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelLoanerMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelLoaner>>>

    export type DestroyModelLoanerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Model Loaner
 */
export const useDestroyModelLoaner = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelLoaner>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelLoaner>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyModelLoanerMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Model Loaner
 */
export const modelLoaner = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelLoaner>(
      {url: `/model-loaners/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelLoanerQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-loaners',id
    ] as const;
    }


export const getModelLoanerQueryOptions = <TData = Awaited<ReturnType<typeof modelLoaner>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelLoaner>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelLoanerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelLoaner>>> = ({ signal }) => modelLoaner(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelLoaner>>, TError, TData>
}

export type ModelLoanerQueryResult = NonNullable<Awaited<ReturnType<typeof modelLoaner>>>
export type ModelLoanerQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Model Loaner
 */

export function useModelLoaner<TData = Awaited<ReturnType<typeof modelLoaner>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelLoaner>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelLoanerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Loaner
 */
export const updateModelLoaner = (
    id: MaybeRefOrGetter<string>,
    modelLoanerInput: MaybeRefOrGetter<ModelLoanerInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelLoanerInput = toValue(modelLoanerInput);

      return axiosClient<ModelLoaner>(
      {url: `/model-loaners/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelLoanerInput, signal
    },
      );
    }




export const getUpdateModelLoanerMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelLoaner>>, TError,{id: string;data: ModelLoanerInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelLoaner>>, TError,{id: string;data: ModelLoanerInput}, TContext> => {

const mutationKey = ['updateModelLoaner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelLoaner>>, {id: string;data: ModelLoanerInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelLoaner(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelLoanerMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelLoaner>>>
    export type UpdateModelLoanerMutationBody = ModelLoanerInput
    export type UpdateModelLoanerMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Model Loaner
 */
export const useUpdateModelLoaner = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelLoaner>>, TError,{id: string;data: ModelLoanerInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelLoaner>>,
        TError,
        {id: string;data: ModelLoanerInput},
        TContext
      > => {
      return useMutation(getUpdateModelLoanerMutationOptions(options), queryClient);
    }
